import AgentChatBackground from '../../../../../../../assets/images/Chat_background/Agent_Chat_background.png';
import { getAssetUrl } from '../../../../../../../utils/assetUtils';
import { format24HourTime } from '../../../../../utils/supportHelpers';
import ReportedIncident from './ReportedIncident';

const TicketMessageStream = ({ selectedTicket, chatEndRef }) => {
  return (
    <div
      className="flex-1 overflow-y-auto p-4 md:p-6 space-y-6 custom-scrollbar"
      style={{
        backgroundImage: `url(${AgentChatBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <ReportedIncident
        issueDescription={selectedTicket.issue_description}
        screenshotUrl={selectedTicket.screenshot_url}
      />

      {selectedTicket.messages?.map((msg, idx) => (
        <div
          key={idx}
          className={`flex ${msg.sender_role === 'agent' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`max-w-[85%] md:max-w-[80%] flex flex-col ${
              msg.sender_role === 'agent' ? 'items-end' : 'items-start'
            }`}
          >
            <div
              className={`px-4 py-3 rounded-2xl text-sm shadow-sm font-medium ${
                msg.sender_role === 'agent'
                  ? 'bg-[#067978] text-white rounded-tr-none'
                  : 'bg-white border border-gray-200 text-gray-800 rounded-tl-none'
              }`}
            >
              {msg.attachment_url && (
                <a
                  href={getAssetUrl(msg.attachment_url)}
                  target="_blank"
                  rel="noreferrer"
                  className="block mb-2 rounded-lg overflow-hidden"
                >
                  <img
                    src={getAssetUrl(msg.attachment_url)}
                    className="max-h-48 w-full object-cover"
                    alt="Chat attachment"
                  />
                </a>
              )}
              {msg.message}
            </div>
            <span className="text-[9px] text-gray-400 mt-1 uppercase font-black tracking-tighter">
              {msg.sender_role === 'agent' ? 'You' : 'Admin'} • {format24HourTime(msg.timestamp)}
            </span>
          </div>
        </div>
      ))}
      <div ref={chatEndRef} />
    </div>
  );
};

export default TicketMessageStream;
